import { AxiosInstance } from 'axios'

import {
  CreateEmployeesAddressRequest,
  UploadEmployeePersonProofAddressRequest,
} from '@modules/employees/types/EmployeesAddresses/requests'
import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'

export class EmployeesAddressesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesAddressRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/addresses`, body)

    return response.data
  }

  async uploadProofAddress({ id, file }: UploadEmployeePersonProofAddressRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('proof', file)

    const response = await this.instance.post(`/companies/employees/${id}/addresses/proof`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesAddressesService = (instance: AxiosInstance) => new EmployeesAddressesService(instance)
